<template>
<div class="person">
    <div class="person__section" >
        <div class="custom-switcher">
            <input type="radio" name="person-mode" id="pm-new" value="new" v-model="personMode" />
            <label for="pm-new">Новый турист</label>
            <template v-if="props.copy_person_list.length">
                <input type="radio" name="person-mode" id="pm-current" value="current" v-model="personMode" />
                <label for="pm-current">Турист текущей заявки</label>
            </template>
            <input type="radio" name="person-mode" id="pm-other" value="other" v-model="personMode" />
            <label for="pm-other">Из других заявок</label>
        </div>

        <div class="person__line" v-if="personMode === 'current' && props.copy_person_list.length">

            <MySelect class="custom-field__field"
                :label="props.copy_person_title"
                :list="props.copy_person_list"
                :choosed="copy_person_val"
                :onlyone="true"
                @input="copy_person_set($event)"
                >
            </MySelect>

            <div class="custom-field">
                <button class="btn btn--blue custom-field__but" :disabled="!copy_person_val" @click="copy_person_do">{{props.copy_person_button}}</button>
                <br />Все ранее введенные поля очистятся
            </div>

        </div>

        <PersonImport v-if="personMode === 'other'" class="person__line" :target="props.sid" />

    </div>
    <div class="person__section">
        <div class="person__line">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_gra"
                title="Гражданство"
                @input="set_document_on_gra"
                :touched="touched"
            />
        </div>
    </div>
    <div class="person__section">
        <!-- ФИО РУС --> 
        <div class="person__line" v-if="is_ru()">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.fname"
                :touched="touched"
                title="Фамилия"
            />

            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.iname"
                :touched="touched"
                title="Имя"
            />

            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.oname"
                :touched="touched"
                title="Отчество"
            />
        </div>
        <div v-else class="person__line">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.flname"
                :touched="touched"
                title="Фамилия латиница"
            />

            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.ilname"
                :touched="touched"
                title="Имя латиница"
            />

        </div>
    </div>

    <div class="person__section">
        <div class="person__line">
            <!-- ПОЛ ДАТА РОЖДЕНИЯ --> 
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.male"
                :touched="touched" 
                title="Пол"
            />
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.born"
                :touched="touched"
                title="Дата рождения"
            />
        </div>
    </div>
    <div class="person__section">
        <div class="person__line">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_type" 
                :touched="touched"
                title="Документ"
            />
        </div>
    </div>
    <div class="person__section">
        <div class="person__line">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_serie" 
                :touched="touched"
                title="Серия"
            />
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_number" 
                :touched="touched"
                title="Номер"
            />
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_issue" 
                :touched="touched"
                title="Дата выдачи" 
            />
            <FieldInputNew v-if="hasValid()" 
                class="custom-field__field"
                :vest="person.vest"
                :field="person.doc_valid"
                :touched="touched"
                title="Действителен до" />
        </div>
        <div v-if="is_ru() && isZps()" class="person__line">

            <!-- КНОПАЧКА --> 
            <div class="custom-field ruen">
                <button class="btn btn--blue custom-field__but" @click="translit_fio(person)">RU-&gt;EN</button>
            </div>


            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.flname"
                :touched="touched"
                title="Фамилия латиница"
            />

            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.ilname"
                :touched="touched"
                title="Имя латиница"
            />
        </div>        
        <div class="person__line" v-if="is_cust && isPs()">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_unitcode"
                :touched="touched" 
                title="Подразделение"
            />
            <FieldInputNew 
                class="custom-field__field"
                :vest="person.vest"
                :field="person.doc_authority"
                :touched="touched"
                title="Кем выдан"
            />
        </div>
        <div class="person__line" v-if="is_cust">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.doc_address"
                :touched="touched" 
                title="Адрес регистрации"
            />
            <FieldInputNew 
                class="custom-field__field"
                :vest="person.vest"
                :field="person.doc_zip"
                :touched="touched"
                title="Почтовый индекс"
            />
        </div>

    </div>


    <div v-if="is_cust" class="person__section">
        <div class="person__section-title">Контактная информация</div>
        <div class="person__line">
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.phone"
                :touched="touched"
                title="Номер телефона"
            />
            <FieldInputNew 
                class="custom-field__field" 
                :vest="person.vest" 
                :field="person.email"
                :touched="touched"
                title="Электронная почта"
            />
        </div>
    </div>
</div>
</template>

<style lang="scss" src="./PersonForm.scss"></style>

<script setup>
import {ref, watch, unref, computed, onMounted, onBeforeUnmount } from 'vue'
import useTouristStore from '@/tourist/tourist-store.js'
import {STATUS_ADL} from '@/tourist/tourist-store.js'
import FieldInputNew from '@/tourist/FieldInputNew.vue'
import MySelect from '@/comp/MySelect/MySelect.vue'
import PersonImport from '@/tourist/PersonImport.vue'
import {translit_and_upper} from '@/tourist/transliterate.js'

const tstore=useTouristStore()

const copy_person_val = ref('') // sid этого туриста мы будем копировать текущий person

const copy_person_set = val => {
    copy_person_val.value = val
}
const copy_person_do = () => {
    const from = unref( copy_person_val.value )
    if (copy_person_val.value) {
        tstore.copy_person( copy_person_val.value, props.sid )
    }
}

const props = defineProps({
    sid : String,
    copy_person_list: {
        type: Array,
        default: ()=>[],
    },
    copy_person_title: {
        type: String,
        default: 'Выберите туриста',
    },
    copy_person_button: {
        type: String,
        default: 'Сделать заказчиком',
    }
})

const touched = computed(() => {
    const ret = tstore.wasTouched( props.sid )
    return ret
})


onBeforeUnmount(() => {
    tstore.touch( props.sid )
})

const person = computed(() => {
    return tstore.person( props.sid )
})
const is_cust = computed(() => {
    return tstore.isCustomer(props.sid)
})

const set_document_on_gra = () => {
    const sid = props.sid
    const p = unref(person)
    if (!p.doc_serie.val && !p.doc_number.val) {
        if ('RU' !== p.doc_gra.val) {
            tstore.set_field( sid, 'doc_type', 'other' )
        } else {
            tstore.set_field( sid, 'doc_type', 'ps' )
        }
    }
}

const is_ru = () => {
    return 'RU' === unref(person).doc_gra.val
}

const hasValid = () => {
    let val = unref(person).doc_type.val 
    let ret = ['zps', 'other'].includes(val)
    return ret
}



const isZps = () => {
    return 'zps' === unref(person).doc_type.val 
}
const isPs = () => {
    return 'ps' === unref(person).doc_type.val 
}


const translit_fio = () => {
    const sid = props.sid
    const p = unref(person)
    tstore.set_field( sid, 'flname', translit_and_upper(p.fname.val) )
    tstore.set_field( sid, 'ilname', translit_and_upper(p.iname.val) )
}

// переключалка вида
const personMode = ref('new')

// не уверен, надо ли чистить
// watch(personMode, (val) => {
//     if (val === 'new') {
//         tstore.clear_person(props.sid)
//     }
// })

</script>
